// src/api/screener.js
import axios from "axios";

const API_BASE = "/screener";

export async function getScreenerResults() {
  const response = await axios.get(`${API_BASE}/results`);
  return response.data?.results ?? [];
}

export async function getFactorRankings() {
  const response = await axios.get(`${API_BASE}/factor-rankings`);
  return response.data?.rankings ?? response.data ?? [];
}

export async function runScreenerScan(params) {
  const payload = {
    universe: params?.universe ?? null,
    min_score: Number(params?.minScore ?? 0),
    limit: Number(params?.limit ?? 25),
    viability_enabled: params?.viabilityEnabled == null ? null : Boolean(params.viabilityEnabled),
    min_price: params?.minPrice == null ? null : Number(params.minPrice),
    min_market_cap: params?.minMarketCap == null ? null : Number(params.minMarketCap),
    require_market_cap: params?.requireMarketCap == null ? null : Boolean(params.requireMarketCap),
  };
  const response = await axios.post(`${API_BASE}/scan`, payload);
  return {
    results: response.data?.results ?? [],
    rejectedSymbols: response.data?.rejected_symbols ?? [],
    requestedUniverseCount: Number(response.data?.requested_universe_count ?? 0),
    eligibleUniverseCount: Number(response.data?.eligible_universe_count ?? 0),
    rejectedCount: Number(response.data?.rejected_count ?? 0),
    viabilityPolicy: response.data?.viability_policy ?? {},
  };
}

export async function refreshScreener() {
  const response = await axios.post(`${API_BASE}/refresh`);
  return response.data?.results ?? [];
}

export async function runShadowEvaluation(params) {
  const payload = {
    universe: params?.universe ?? null,
    min_score: Number(params?.minScore ?? 0),
    limit: Number(params?.limit ?? 25),
    baseline_api_calls_per_symbol: Number(params?.baselineApiCallsPerSymbol ?? 2),
    candidate_api_calls_per_symbol: Number(params?.candidateApiCallsPerSymbol ?? 0),
    top_n: params?.topN == null ? null : Number(params.topN),
  };
  const response = await axios.post(`${API_BASE}/shadow-run`, payload);
  return response.data;
}

export async function getLatestShadowRun() {
  const response = await axios.get(`${API_BASE}/shadow-run/latest`);
  return response.data;
}

export async function getShadowEvaluationHistory(limit = 10) {
  const response = await axios.get(`${API_BASE}/shadow-evaluate/history`, {
    params: { limit },
  });
  return response.data?.history ?? [];
}

export async function getReadinessGate() {
  const response = await axios.get(`/portfolio/readiness-gate`);
  return response.data;
}

export async function snapshotReadinessGate() {
  const response = await axios.post(`/portfolio/readiness-gate/snapshot`);
  return response.data ?? null;
}

export async function getReadinessGateHistory(limit = 10) {
  const response = await axios.get(`/portfolio/readiness-gate/history`, {
    params: { limit },
  });
  return response.data?.history ?? [];
}

export async function getReadinessAlerts(limit = 10) {
  const response = await axios.get(`/portfolio/readiness-alerts`, {
    params: { limit },
  });
  return response.data?.alerts ?? [];
}
